<template>
  <v-dialog v-model="dialog" :fullscreen="isMobile" width="800" max-width="800">
    <v-card class="article-serials-card">
      <div class="d-flex align-center px-4 pt-3">
        <p class="font-weight-medium mb-0">{{ $t("serials") }}</p>
        <v-spacer />
        <v-btn icon color="grey darken-2" @click="close">
          <v-icon class="close-hover" large>mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="d-flex justify-space-between align-center px-4 py-3 serials-info-bar">
        <span>{{ product?.name || "-" }}</span>
        <span>{{ serials.length }} {{ $t("serial") }}</span>
      </div>

      <div class="px-4 pt-3 pb-2 mb-6">
        <v-text-field
          v-model="search"
          outlined
          dense
          height="41"
          hide-details
          prepend-inner-icon="mdi-magnify"
          :placeholder="$t('search-in-serials')"
          clearable
        />
      </div>

      <div
        class="serials-table-wrapper px-4"
        :class="{ 'serials-table-wrapper--scrollable': filteredSerials.length > 6 }"
      >
        <v-simple-table dense class="serials-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th>{{ $t("row") }}</th>
                <th>{{ $t("serial") }}</th>
                <th>{{ $t("entrepot-name") }}</th>
                <th>{{ $t("input-invoice-number") }}</th>
                <!-- <th>{{ $t("output-invoice-number") }}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(serial, i) in filteredSerials" :key="i">
                <td class="serials-row-index">{{ i + 1 }}</td>
                <td class="serials-value">{{ serial?.serial || "-" }}</td>
                <td>{{ serial?.entrepot?.name || "-" }}</td>
                <td>{{ serial?.in_entrepot?.invoice_id || "-" }}</td>
                <!-- <td>{{ serial?.out_invoice?.number || "-" }}</td> -->
              </tr>
              <tr v-if="!filteredSerials.length">
                <td colspan="5" class="text-center grey--text py-4">
                  {{ $t("no-serial-found") }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <v-divider />
      <v-card-actions class="serials-footer px-4">
        <v-spacer />
        <v-btn outlined color="grey darken-1" @click="close">
          {{ $t("cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ArticleSerialsDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    serials: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "sm" || this.$vuetify.breakpoint.xs;
    },
    filteredSerials() {
      const q = (this.search || "").trim().toLowerCase();
      if (!q) return this.serials || [];
      return (this.serials || []).filter((serial) => {
        const text = [
          serial?.serial,
          serial?.entrepot?.name,
          serial?.in_invoice?.number,
          // serial?.out_invoice?.number,
        ]
          .join(" ")
          .toLowerCase();
        return text.includes(q);
      });
    },
  },
  watch: {
    dialog(val) {
      if (val) this.search = "";
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.serials-info-bar {
  background: #e8f1ff;
  color: #0066ff;
  font-weight: 600;
}
.serials-table-wrapper {
  width: 100%;
  padding-bottom: 8px;
}
.serials-table-wrapper--scrollable {
  max-height: 320px;
  overflow-y: auto;
}
.serials-table-wrapper--scrollable ::v-deep thead th {
  position: sticky;
  top: 0;
  z-index: 2;
}
.serials-table thead th {
  background: #bab9b9;
  color: #fff !important;
  white-space: nowrap;
}
.serials-row-index {
  color: #858585;
  white-space: nowrap;
  width: 1%;
}
.serials-value {
  direction: ltr;
  text-align: right;
  font-family: monospace;
}
.serials-footer {
  background: #f0f3f6;
}
</style>
